/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';
import { getComponentFromName } from '../../lib/utils';

import downloadIcons from '../../../img/download-buttons';
import Button from '../buttons/LinkButton';
import * as Logos from '../icons/logos';
import Detector from './Detector';
import Slider from './Slider';

import styles from '../../../styles/partials/property.module.scss';

const propTypes = {
    handle: PropTypes.string,
    description: PropTypes.string,
    mediaKit: PropTypes.string,
    cards: AppPropTypes.cards,
    url: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    handle: null,
    description: null,
    mediaKit: null,
    cards: null,
    url: null,
    className: null,
};

const Property = ({ handle, cards, description, mediaKit, url, className }) => {
    const [visible, setVisible] = useState(false);
    const LogoComponent = getComponentFromName(Logos, handle);
    const downloadIcon =
        downloadIcons[handle] !== undefined ? downloadIcons[handle] : downloadIcons.urbania;

    return (
        <Detector
            onEnter={() => setVisible(true)}
            onLeave={() => setVisible(false)}
            rootMargin="-20%"
        >
            <div
                className={classNames([
                    styles.container,
                    styles.background,
                    styles[`${handle}Bg`],
                    {
                        [styles.visible]: visible,
                        [className]: className !== null,
                    },
                ])}
            >
                <div className={styles.inner}>
                    <Slider
                        className={styles.slider}
                        cards={cards}
                        cardsTheme={handle}
                        detailsClassName={styles.details}
                        logoClassName={classNames([styles.logo, styles[`${handle}Logo`]])}
                        LogoComponent={LogoComponent}
                        description={description}
                        descriptionClassName={styles.text}
                        mediaKit={mediaKit}
                        downloadIcon={downloadIcon}
                        downloadButtonClassName={styles[`${handle}DownloadButton`]}
                        cardsClassName={styles.cardsList}
                        cardClassName={styles.card}
                        visible={visible}
                        accentColor={
                            handle === 'urbania' || handle === 'universites' ? 'black' : 'white'
                        }
                    />
                    <div className={styles.bottom}>
                        <Button
                            href={url}
                            external
                            className={styles.viewProjectLink}
                            innerClassName={styles.viewProjectLinkInner}
                            backgroundColor="transparent"
                        >
                            <FormattedMessage
                                values={{
                                    name: handle === 'universites' ? 'Période libre' : handle,
                                }}
                                defaultMessage="Visit {name}"
                                description="Site link button"
                            />
                        </Button>
                    </div>
                </div>
            </div>
        </Detector>
    );
};

Property.propTypes = propTypes;
Property.defaultProps = defaultProps;

export default Property;
